export type CscaSystemType =
  | 'past_paper'
  | 'topic_practice'
  | 'random_paper'
  | 'mooc_topic_practice'
  | 'mooc_random';

export interface CscaTestDescriptor {
  level?: number | null;
  system_type?: string | null;
  systemType?: string | null;
  paper_year?: number | null;
  paperYear?: number | null;
  paper_month?: number | null;
  paperMonth?: number | null;
  topic_coarse?: string | null;
  topicCoarse?: string | null;
  topic_fine?: string | null;
  topicFine?: string | null;
}

const CSCA_SUBJECTS: Record<number, string> = {
  1: '中文文科（IPS）',
  2: '中文理科（IPA）',
  3: '数学',
  4: '物理',
  5: '化学',
};

const getSystemType = (test: CscaTestDescriptor) => String(test.system_type || test.systemType || '');

export const isCscaSprintReview = (test: CscaTestDescriptor) =>
  getSystemType(test) === 'past_paper' && Number(test.level) === 2 &&
  Number(test.paper_year ?? test.paperYear) === 2026 && [4, 6].includes(Number(test.paper_month ?? test.paperMonth));

export const getCscaSubjectName = (level?: number | null) =>
  CSCA_SUBJECTS[Number(level || 0)] || `科目 ${Number(level || 0) || '-'}`;

export const isCscaPendingReview = (question: any) =>
  /^CSCA_/.test(String(question?.id || question?.question_id || '')) &&
  (question?.gradingPending === true || question?.grading_pending === true || Number(question?.correctAnswer ?? question?.correct_option_index) === -1);

export const getCscaModeLabel = (test: CscaTestDescriptor) => {
  switch (getSystemType(test)) {
    case 'past_paper': return isCscaSprintReview(test) ? '冲刺复习卷' : 'Past Paper';
    case 'topic_practice': return 'Topic Practice';
    case 'random_paper': return 'Random Paper';
    case 'mooc_topic_practice': return 'MOOC Topic';
    case 'mooc_random': return 'Random MOOC';
    default: return 'CSCA Simulation';
  }
};

export const getCscaModeDetail = (test: CscaTestDescriptor) => {
  const systemType = getSystemType(test);
  const year = test.paper_year ?? test.paperYear;
  const month = test.paper_month ?? test.paperMonth;
  const coarse = test.topic_coarse ?? test.topicCoarse;
  const fine = test.topic_fine ?? test.topicFine;

  if (systemType === 'past_paper' && year && month) return `${year}年${month}月`;
  if ((systemType === 'topic_practice' || systemType === 'mooc_topic_practice') && coarse) {
    return fine ? `${coarse} / ${fine}` : coarse;
  }
  if (systemType === 'random_paper') return '按往年真题结构随机组卷';
  if (systemType === 'mooc_random') return '从 MOOC 题库随机组卷';
  return '';
};

export const getCscaTestTitle = (test: CscaTestDescriptor) =>
  `CSCA ${getCscaSubjectName(test.level)} · ${getCscaModeLabel(test)}`;
